export default __webpack_public_path__ + "static/media/transaction-icon.6e796341.svg";